import { PaletteOptions } from '@mui/material';

const mutedGreenPalette: PaletteOptions = {
  primary: {
    25: '#F4FBF3',
    50: '#E9F7E8',
    100: '#D4F0D2',
    200: '#BFE5BD',
    300: '#AAD0A8',
    400: '#95BA93',
    500: '#80A47D',
    600: '#6C8E68',
    700: '#587454',
    800: '#455A42',
    900: '#2D3B2A',
    main: '#6C8E68',
  },
  secondary: {
    25: '#FFFAE5',
    50: '#FFF6CA',
    100: '#FFF1B0',
    200: '#FFED95',
    300: '#FEE87B',
    400: '#FEE360',
    500: '#FEDF46',
    600: '#FEDA2B',
    700: '#BFA320',
    800: '#7F6D16',
    900: '#40370B',
    main: '#FEDA2B',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
  },
  neutral: {
    25: '#F8F8F8',
    50: '#F0F0F0',
    100: '#E1E1E1',
    200: '#D7D7D7',
    300: '#888888',
    400: '#707070',
    500: '#585858',
    600: '#4C4C4C',
    700: '#383838',
    800: '#2F2F2F',
    900: '#181818',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#F4FBF3',
    300: '#E9F7E8',
    500: '#D4F0D2',
    600: '#BFE5BD',
    700: '#AAD0A8',
    800: '#587454',
    main: '#D4F0D2',
  },
  background: {
    default: '#383838',
    paper: '#383838',
  },
  text: {
    primary: '#fff',
    secondary: '#bcd6c0',
    disabled: '#6c866d',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#D4F0D2',
    duration: '#E9F7E8',
    cardBackground: '#455A42',
    buttonBorder: '#2D3B2A',
    buttonBackground: '#6C8E68',
    buttonBackgroundHover: '#587454',
    separator: '#6C8E6866',
  },
} as const;

export default mutedGreenPalette;
